/**
* PORT-9
* Версионирование
* Блок: Левое меню
* Раздел: Документация
* Аналог сервиса: https://about.readthedocs.com/
 **/

import "./versions.css"
import {lang, route_parse} from "../function.js";
const path = window.location.pathname.split("/")
const category_doc = path[4]
const v_current = path[5]


const versiontag=$(".versiontag").text()
$(".versiontag").text("")
export const current_lang = $("html").attr("lang");
let current_dark = $("html").hasClass("dark")
let icon_color = "#11181c"
if (current_dark) icon_color = "#e1e7ef"


let icon_book = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="${icon_color}" d="M96 0C43 0 0 43 0 96L0 416c0 53 43 96 96 96l288 0 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-64c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L384 0 96 0zm0 384l256 0 0 64L96 448c-17.7 0-32-14.3-32-32s14.3-32 32-32zm32-240c0-8.8 7.2-16 16-16l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16zm16 48l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"/></svg>`
let icon_caret_down = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path  fill="${icon_color}"  d="M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z"/></svg>`



export const version_list = new jqueryts.DataCollection({
    url: function (){
        const route=route_parse()
        if (route[3]!=="sphinx") return []
        return jqueryts.ajax().get(`/${current_lang}/version/${category_doc}`).then(res => {
            res = res.json()
            res=res[current_lang].map(el=>{
                if (el=="latest")
                    return {id:el, value:$("#version_sphinx").text()}
                return {id:el, value:el}
            })
            return res;
        })
    }
});
jqueryts.promise.all([
    version_list.waitData
]).then(function (results) {
    $$("version_list").setValue(v_current)
})

let block_versions= document.querySelector("div.block_versions");
if (window.screen.width<1260){
    block_versions= document.querySelector("div.mm_block_versions");
}
jqueryts.ui({
    container: block_versions,
    css: "bg",
    rows: [
        {
            id: "version_list",
            view:"richselect",
            width: 150,
            options:{
                view: "suggest",
                template:`<div  class="block_text_version"><span class="icon_book">${icon_book}</span><span>#value#</span></div>`,
                data: version_list
            },
            on:{
                onChange:function (val, old, config){
                    if (config===undefined) return;
                    if (config=="user"){
                        let href=window.location.pathname.split("/")
                        href[5]=val;
                        window.location.href=href.join("/")
                    }
                }
            }
        }
    ],
});
